import styled from 'styled-components'

import Flex from '../../../layout/Flex/Flex'

export const DataTableActionBarWrapper = styled(Flex)`
  padding-left: ${props => props.theme.spacings.medium};
  padding-right: ${props => props.theme.spacings.medium};
`
